import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Cookie from "js-cookie";

import student_Store from "../store/student_store";
import ExportCSV from "../functions/ExportCSV";
import Selector_Component from "../component/Selector_Component";
import supervisor_Store from "../store/supervisor_store";
import admin_Store from "../store/admin_store";
import CurrUser from "../functions/UserAuth";
import Student_Manage_Modal from "../component/Student_Manage_Modal";
import { useLocation } from "react-router-dom";

function Transcript_Page({ data }) {
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();

  if (location?.state != "") {
    data = location?.state?.data;
  }
  const student = location?.state?.student;

  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "100px",
      id: 1,
    },
    {
      name: "Course Name",
      selector: (row) => row?.course_name,
      id: 2,
    },
    {
      name: "Course Code",
      selector: (row) => row?.course_code ?? "",
      id: 3,
    },
    {
      name: "Status",
      selector: (row) => row?.status ?? "",
      id: 3,
    },
   
  ];

  let [mydata, setMydata] = useState([]);

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handlePageChange = (page) => {
    setPage(page);
  };
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  function onChange(e) {
    let word = e.target.value;
    const result = data.filter(
      (transcript) =>
        (transcript.course_name &&
          transcript.course_name.toLowerCase().includes(word.toLowerCase())) ||
        transcript.course_code.toLowerCase().includes(word) ||
        transcript?.id == word
    );
    setMydata(result);

    if (word === "") {
      setMydata([]);
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }
  function exportTable() {
    let arr = mydata.length > 0 ? mydata : data;
    if ((arr?.length ?? 0) == 0) return;
    arr.forEach((obj, index) => (obj.id = index + 1));
    arr.forEach((obj) => delete obj.created_at);
    ExportCSV(arr, `Transcript ${data[0].student_code}`);
  }
  return (
    <>
      <div className="d-flex bd-highlight">
        <div className="pt-2 flex-grow-1 bd-highlight">
          <input
            type="text"
            onChange={(e) => onChange(e)}
            className="form-control w-50"
            placeholder="Search.."
            required
            aria-label=""
            aria-describedby="basic-addon1"
          />
        </div>

        <div className="p-2 bd-highlight">
          <button
            onClick={async function () {
              exportTable();
            }}
            className="btn   btn-md btn btn-outline-primary"
            type="button"
          >
            CSV
          </button>
        </div>
      </div>
      <br />
      Student: {student.name}
      <br />
      Student Code: {student.code}
      <br />
      Cum Gpa: {data?.[0]?.cum_gpa}
      <br />
      ECredit: {data?.[0]?.ecreds}
      <br />
      <br />
      {/* <h1>{tokennn}</h1> */}
      <DataTable
        columns={columns}
        data={mydata?.length > 0 ? mydata : data}
        progressPending={false}
        // pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={mydata?.length > 0 ? mydata?.length : data?.length}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />
    </>
  );
}

export default Transcript_Page;
